import { render, staticRenderFns } from "./RequiredDocumentsPanel.vue?vue&type=template&id=626404f6&scoped=true"
import script from "./RequiredDocumentsPanel.vue?vue&type=script&lang=ts"
export * from "./RequiredDocumentsPanel.vue?vue&type=script&lang=ts"
import style0 from "./RequiredDocumentsPanel.vue?vue&type=style&index=0&id=626404f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626404f6",
  null
  
)

export default component.exports